import React, { useContext, useState } from 'react';
import { ColumnsType } from 'antd/es/table/interface';
import dayjs from 'dayjs';

import BouncedEmailDetailsContext from '@totem/components/administration/bouncedEmails/details/BouncedEmailDetailsContext';
import { BouncedEmailHistoryEntry } from '@totem/components/administration/bouncedEmails/types';
import IBTable from '@totem/components/ui_components/antDesignOverrides/IBTable';

const BouncedEmailHistoryTable = () => {
  const { details } = useContext(BouncedEmailDetailsContext);
  const [pageSize, setPageSize] = useState<number>(10);

  type HistoryRow = BouncedEmailHistoryEntry & { key: number };

  const history: HistoryRow[] = (details?.record?.history ?? [])
    .map((entry, idx) => ({ ...entry, key: idx }))
    .sort(
      (first, second) =>
        dayjs(second.timestamp).valueOf() - dayjs(first.timestamp).valueOf() ||
        second.key - first.key,
    );

  const columns: ColumnsType<HistoryRow> = [
    {
      title: 'When',
      dataIndex: 'timestamp',
      key: 'timestamp',
      width: 170,
      render: (value: string) => dayjs(value).format('YYYY-MM-DD HH:mm'),
    },
    { title: 'Action', dataIndex: 'action', key: 'action', width: 220 },
    { title: 'Detail', dataIndex: 'detail', key: 'detail' },
    { title: 'By', dataIndex: 'userName', key: 'userName', width: 180 },
  ];

  return (
    <IBTable<HistoryRow>
      columns={columns}
      dataSource={history}
      rowKey="key"
      pagination={{
        pageSize,
        showSizeChanger: true,
        onShowSizeChange: (_, size) => setPageSize(size),
      }}
    />
  );
};

export default BouncedEmailHistoryTable;
